/**
 * @file   src\components\MainMenu.tsx
 * @brief  Menu component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { pageURLs } from '../utils/pageUrls';
import { Nav, NavDropdown, Link, useState, useNavigate, useEffect, React } from '../utils/thirdpartyComponents';
import { getFromLocalStorage } from '../utils/helper';
export interface NavigationState {
  origin: string;
}

const MainMenu = (props: any) => {
  const navigationState: NavigationState = { origin: 'MainMenu' };
  const storageData = getFromLocalStorage('CARWASH_ADMIN_DATA');
  const userInfo = storageData && storageData !== null ? storageData : null;


  const [activeLink, setActiveLink] = useState<string>(props.active_menu); // Default active link

  const navigate = useNavigate()

  // On change of prop ,rerendering is done.
  useEffect(() => {
    setActiveLink(props.active_menu)
  }, [props])

  const handleLinkClick = (url: string) => {
    setActiveLink(url)
    navigate(url, {
      state: { origin: 'MainMenu' }
    })
  }


  return (
    <div className="d-flex nav-items sm-hide">
      <Link
        to={`/superadmin/${pageURLs.manage_carwash}`}
        state={navigationState as any}

        className={activeLink === "manage-car-wash" ? 'f-medium active' : 'f-medium'}
        onClick={() => handleLinkClick(`/superadmin/${pageURLs.manage_carwash}`)}>Manage Car Washes
      </Link>
      {userInfo?.userTypeId == 2 && userInfo?.permissionType == 2 ? <Link
        to={`/superadmin/${pageURLs.order_list}`} className={activeLink === "manage-hardware" ? 'f-medium active' : 'f-medium'} onClick={() => handleLinkClick(`/superadmin/${pageURLs.order_list}`)}>Manage Order</Link> : <Link
          to={`/superadmin/${pageURLs.manage_hardware}`} className={activeLink === "manage-hardware" ? 'f-medium active' : 'f-medium'} onClick={() => handleLinkClick(`/superadmin/${pageURLs.manage_hardware}`)}>Hardware Listing</Link>}
      {!(userInfo?.userTypeId == 2 && userInfo?.permissionType == 2)
        && <Link to={`/superadmin/${pageURLs.manage_admin_subscription}`} className={activeLink === "manage-admin-subscriptions" ? 'f-medium active' : 'f-medium'} onClick={() => handleLinkClick(`/superadmin/${pageURLs.manage_admin_subscription}`)}>Manage Subscriptions</Link>}
      {!(userInfo?.userTypeId == 2 && userInfo?.permissionType == 2)
        && <Link to={`/superadmin/${pageURLs.pax_device_listing}`} className={activeLink === "pax-device-listing" ? 'f-medium active' : 'f-medium'} onClick={() => handleLinkClick(`/superadmin/${pageURLs.pax_device_listing}`)}>Manage Paxdevice</Link>}

      {!(userInfo?.userTypeId == 2 && userInfo?.permissionType == 2)
        && <Nav>
          <NavDropdown
            title="Reports"
            align="end"
          >
            <NavDropdown.Item href="#" onClick={() => navigate(`/superadmin/${pageURLs.revenue_reports}`)}>Revenue Reports</NavDropdown.Item>
          </NavDropdown>
        </Nav>}
        
    </div >
  );
};
export default MainMenu;
